import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { IOptionType } from 'interfaces/forms';

import { TERMS_OPTIONS } from 'components/BusinessToolForm/constants/options';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.ABOUT_COMPANY}.${BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.MISSION_AND_STRATEGY}` as const;

// GOALS

export const GOAL_ROW_NAMES = {
  GOAL: 'goal',
  PRIORITY: 'priority',
  TERMS: 'terms',
  SCHEDULED_DATE: 'scheduledDate',
  MECHANISM_OF_ACHIEVEMENT: 'mechanismOfAchievement',
} as const;

export interface IGoalAndObjectiveRowForm {
  [GOAL_ROW_NAMES.GOAL]: string;
  [GOAL_ROW_NAMES.PRIORITY]: IOptionType | string | null;
  [GOAL_ROW_NAMES.TERMS]: IOptionType | null;
  [GOAL_ROW_NAMES.SCHEDULED_DATE]: string;
  [GOAL_ROW_NAMES.MECHANISM_OF_ACHIEVEMENT]: string;
}

export const goalAndObjectiveRowInitialValues: IGoalAndObjectiveRowForm = {
  [GOAL_ROW_NAMES.GOAL]: '',
  [GOAL_ROW_NAMES.PRIORITY]: '',
  [GOAL_ROW_NAMES.TERMS]: TERMS_OPTIONS[0],
  [GOAL_ROW_NAMES.SCHEDULED_DATE]: '',
  [GOAL_ROW_NAMES.MECHANISM_OF_ACHIEVEMENT]: '',
};

// FORM
export const ABOUT_COMPANY_MISSION_NAMES = {
  VISION_OF_FUTURE: 'visionOfFuture',
  CORE_VALUES: 'coreValues',
  PROBLEM_OF_MARKET: 'problemOfMarket',
  GOALS: 'goals',
  HOW_PROJECT_ADDRESSES_THE_PROBLEM: 'howProjectAddressesTheProblem',
} as const;

export interface IAboutCompanyMissionForm {
  [ABOUT_COMPANY_MISSION_NAMES.VISION_OF_FUTURE]: string;
  [ABOUT_COMPANY_MISSION_NAMES.CORE_VALUES]: string;
  [ABOUT_COMPANY_MISSION_NAMES.PROBLEM_OF_MARKET]: string;
  [ABOUT_COMPANY_MISSION_NAMES.GOALS]: IGoalAndObjectiveRowForm[];
  [ABOUT_COMPANY_MISSION_NAMES.HOW_PROJECT_ADDRESSES_THE_PROBLEM]: string;
}

export const aboutCompanyMissionInitialValues: IAboutCompanyMissionForm = {
  [ABOUT_COMPANY_MISSION_NAMES.VISION_OF_FUTURE]: '',
  [ABOUT_COMPANY_MISSION_NAMES.CORE_VALUES]: '',
  [ABOUT_COMPANY_MISSION_NAMES.PROBLEM_OF_MARKET]: '',
  [ABOUT_COMPANY_MISSION_NAMES.GOALS]: [goalAndObjectiveRowInitialValues],
  [ABOUT_COMPANY_MISSION_NAMES.HOW_PROJECT_ADDRESSES_THE_PROBLEM]: '',
};
